import { Component } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatInputModule } from '@angular/material/input'
import { MatSelectModule } from '@angular/material/select'
import { MatButtonModule } from '@angular/material/button'
import { MatIconModule } from '@angular/material/icon'
import { MatDatepickerModule } from '@angular/material/datepicker'
import { MatProgressBarModule } from '@angular/material/progress-bar'
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog'
import moment from 'moment/moment'
import { DriverService } from '../../../../core/services/driver/driver/driver.service'
import { MotoristaImpedimentoService } from '../../../../core/services/driver/motorista-impedimento/motorista-impedimento.service'
import { SnackbarCustomService } from '../../../../shared/components/snackbar/snackbar-custom.service'
import {
  TIPOS_IMPEDIMENTO,
  TIPO_IMPEDIMENTO_REDUCAO_JORNADA,
} from '../../../../core/models/motorista-impedimento.model'

@Component({
  selector: 'impedimento-form-dialog',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatButtonModule,
    MatIconModule,
    MatDatepickerModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatDialogModule,
  ],
  templateUrl: './impedimento-form-dialog.component.html',
  standalone: true,
})
export class ImpedimentoFormDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ImpedimentoFormDialogComponent>,
    private formBuilder: FormBuilder,
    private driverService: DriverService,
    private impedimentoService: MotoristaImpedimentoService,
    private snackbar: SnackbarCustomService,
  ) {
    this.createForm()
  }

  tiposImpedimento = TIPOS_IMPEDIMENTO
  tipoReducaoJornada = TIPO_IMPEDIMENTO_REDUCAO_JORNADA

  buscaMotorista = ''
  buscandoMotorista = false
  resultadosMotorista: any[] = []
  motoristaSelecionado: any = null

  form: FormGroup = new FormGroup({})
  salvando = false

  createForm(): void {
    this.form = this.formBuilder.group({
      tipoImpedimentoId: ['', Validators.required],
      dataInicio: ['', Validators.required],
      dataFim: ['', Validators.required],
      horaInicio: [''],
      horaFim: [''],
      observacao: [''],
    })
  }

  get exigeJanelaHora(): boolean {
    return this.form.get('tipoImpedimentoId')?.value === this.tipoReducaoJornada
  }

  buscarMotorista(): void {
    if (!this.buscaMotorista) {
      this.resultadosMotorista = []
      return
    }
    this.buscandoMotorista = true
    this.driverService
      .searchPagedDriver(1, 15, {
        nome: this.buscaMotorista,
        cpf: '',
        numeroRegistro: '',
        categoria: '',
        isfuncionario: '',
        matricula: '',
        tipoMotoristaId: 0,
      })
      .subscribe({
        next: (res: any) => {
          this.resultadosMotorista = res.data ?? []
          this.buscandoMotorista = false
        },
        error: (err: any) => {
          this.snackbar.errorRequest(err)
          this.buscandoMotorista = false
        },
      })
  }

  selecionarMotorista(motorista: any): void {
    this.motoristaSelecionado = motorista
    this.resultadosMotorista = []
    this.buscaMotorista = ''
  }

  trocarMotorista(): void {
    this.motoristaSelecionado = null
    this.form.reset()
  }

  cancelar(): void {
    this.dialogRef.close(false)
  }

  adicionar(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched()
      return
    }
    const v = this.form.value
    if (this.exigeJanelaHora && (!v.horaInicio || !v.horaFim)) {
      this.snackbar.error('Redução de jornada precisa da janela de hora (início e fim).')
      return
    }
    this.salvando = true
    const model = {
      motoristaId: this.motoristaSelecionado.id,
      tipoImpedimentoId: v.tipoImpedimentoId,
      dataInicio: moment(v.dataInicio).format('DD/MM/YYYY'),
      dataFim: moment(v.dataFim).format('DD/MM/YYYY'),
      horaInicio: this.exigeJanelaHora ? v.horaInicio : null,
      horaFim: this.exigeJanelaHora ? v.horaFim : null,
      observacao: v.observacao || '',
    }
    this.impedimentoService.create(model).subscribe({
      next: (res: any) => {
        this.snackbar.success(res.message ?? 'Impedimento lançado com sucesso.')
        this.salvando = false
        this.dialogRef.close(true)
      },
      error: (err: any) => {
        this.salvando = false
        this.snackbar.errorRequest(err)
      },
    })
  }
}
